angular.module('impactx.MenuDirectives').controller('DeactivateThemeWorldCtrl', [
    '$scope',
    '$context',
    'TranslationService',
    'ThemeWorldService',
    'ToastService',
    '$redirect',
    'dataGen',
    DeactivateThemeWorldCtrl]);

function DeactivateThemeWorldCtrl($scope, $context, TranslationService, ThemeWorldService, ToastService, $redirect, dataGen) {
    let self = this;
    self.showDeactivationButton = false;

    $scope.$watch(function() {
        return $context.hasActiveThemeWorld.value
    }, function(newValue) {
        self.showDeactivationButton = newValue;
        self.deactivateThemeWorld = TranslationService.get('stopEditThemeWorld');
    });

    self.deactivateCurrentThemeWorld = function() {
        var previousThemeWorldId = $context.hasActiveThemeWorld.id;

        ThemeWorldService.deactivateActiveThemeWorld().then(function(data) {
            $context.refreshSearchInfo({}, dataGen, $context).then(function() {
                ToastService.openStandardToast(data.trns.vcatDeactivated);
                $redirect.redirectTo(null, "/themeworld/" + previousThemeWorldId);
            });
        });
    };
}